module.exports = __webpack_public_path__ + "media/flags/mt-efdd09cd.svg";